import { useEffect, useRef, useState } from 'react';
import { NoRecords, PageLoader } from '../../lib/loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { ReferralRewardTransaction } from './UserDetailapi';
import { ArrowUp, ArrowDown, Copy, Check, Search } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useModalContext } from '../../contexts/ModalContext';
import { useToast } from '../../hooks/usetoast';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';
import { useDebounce } from '../../hooks/debounce';
import PropTypes from 'prop-types';


function ReferralRewardHistory({ userDetail }) {
    const { theme } = useModalContext()
    const toast = useToast();
    const [sortOrder, setSortOrder] = useState("desc");
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const searchText = useDebounce(search);

    const { id } = useParams();
    const [referralEmail, setReferralEmail] = useState(false);

    const { data: getReferralRewardHistory, isLoading } = ReferralRewardTransaction({
        id,
        userId: id,
        page: searchText ? 0 : tempPage,
        size: tempRows,
        sortField: "createdAt",
        sortOrder
    });

    const totalRecords = getReferralRewardHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    const copyReferralEmailAddress = async data => {
        setReferralEmail(data._id)
        await copyToClipboard(data?.referUserId?.email)
        toast.success(" Referral Email Address copied")
        setTimeout(() => {
            setReferralEmail()
        }, 800)
    }


    const copyTxnhashAddress = async data => {
        await copyToClipboard(data)
        toast.success("Hash copied")
        setTimeout(() => {

        }, 800)
    }

    const renderTotalReferralRewardhistoryTable = () => (
        getReferralRewardHistory?.data?.usersHistory?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="Referral transaction history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap' align="center">S.NO</TableCell>
                                    <TableCell className='text-nowrap' align="center">Level</TableCell>
                                    <TableCell className='text-nowrap' align="center">Refer Email</TableCell>
                                    <TableCell className='text-nowrap' align="center">Hash</TableCell>
                                    <TableCell className='text-nowrap' align="center">TYPE</TableCell>

                                    <TableCell className='text-nowrap' align="center">Referral Id</TableCell>
                                    <TableCell className='text-nowrap' align="center">Reward Amount</TableCell>
                                    <TableCell className='text-nowrap' align="center">Reward Status</TableCell>

                                    <TableCell className='text-nowrap' align="center">
                                        Date & Time{' '}
                                        {sortOrder !== 'desc' ? (
                                            <ArrowUp
                                                onClick={() => setSortOrder('desc')}
                                                style={{ cursor: 'pointer' }}
                                                aria-label="Sort descending"
                                            />
                                        ) : (
                                            <ArrowDown
                                                onClick={() => setSortOrder('asc')}
                                                style={{ cursor: 'pointer' }}
                                                aria-label="Sort ascending"
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getReferralRewardHistory?.data?.usersHistory?.map((row, i) => (
                                    <TableRow key={row?._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row.userLevel}</TableCell>
                                        <TableCell align="center">
                                            {row?.referUserId?.email || "-"}
                                            {referralEmail === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyReferralEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.referUserId?.email === userDetail?.data?.email ? (
                                                <>
                                                    {row?.fromTxnHash?.slice(0, 3)}...{row?.fromTxnHash?.slice(-3)}
                                                    <Copy
                                                        onClick={() => copyTxnhashAddress(row?.fromTxnHash)}
                                                        size={20}
                                                        className="ml-5"
                                                        style={{
                                                            cursor: "pointer",
                                                            marginLeft: "5px",
                                                            color: theme ? "white" : "black"
                                                        }}
                                                    />
                                                </>
                                            ) : row?.toTxnHash ? (
                                                <>
                                                    {row?.toTxnHash.slice(0, 3)}...{row?.toTxnHash.slice(-3)}
                                                    <Copy
                                                        onClick={() => copyTxnhashAddress(row?.toTxnHash)}
                                                        size={20}
                                                        className="ml-5"
                                                        style={{
                                                            cursor: "pointer",
                                                            marginLeft: "5px",
                                                            color: theme ? "white" : "black"
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </TableCell>
                                        <TableCell align="center"> {row.rewardType === "Type-II" ? "Spending Reward" : "Top-Up Reward"}</TableCell>
                                        <TableCell align="center">{row?.referUserId?.referralId || '-'}</TableCell>
                                        <TableCell className="text-nowrap" align="center">
                                            {row?.rewardAmount ? (
                                                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                    {row.rewardAmount}
                                                    {row?.currencyImage && (
                                                        <img
                                                            src={row.currencyImage}
                                                            alt="Currency Icon"
                                                            style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                borderRadius: '50%',
                                                                verticalAlign: 'middle',
                                                                objectFit: 'cover',
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            ) : (
                                                '-'
                                            )}
                                        </TableCell>
                                        <TableCell align="center">{row?.rewardStatus || "-"}</TableCell>
                                        <TableCell align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );

    return (
        <section>
            <h4>Referral Reward History</h4>
            <div className="ad_pg_bx bg-white p-3">
                <div className='d-flex justify-content-between align-items-center mb-2'>
                    <div className='col-md-4'>
                        <div className="input-group">
                            <span className="input-group-icon">
                                <Search size={20} color='#aaa9a9' />
                            </span>
                            <input
                                type="text"
                                ref={inputRef}
                                onChange={(e) => setSearch(e.target.value)}
                                className="form-control"
                                placeholder="Search Email"
                            />
                        </div>
                    </div>
                </div>
                {isLoading ? (
                    <PageLoader />
                ) : (
                    renderTotalReferralRewardhistoryTable()
                )}
            </div>
        </section>
    );
}

ReferralRewardHistory.propTypes = {
    userDetail: PropTypes.any,
};


export default ReferralRewardHistory;